import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable the Q1 2024 experimental interventions for login latency.
 * See https://www.notion.so/faire/Login-Latency-Reduction-Plan-Q1-2024-2da5f972eb534ea2b004248e3c40c89d?pvs=4
 * @deprecated Removed on backend, waiting for frontend removal
 */
export const ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119 =
  'ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119' as SettingConst<
    'ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'BRAND_ANDROID' | 'VISITOR_WEB'
  >;
